import { useState, useRef, useEffect } from "react";
import { Container, VLine, Tooltip } from "./styles";
import { IItemHistoricoPlano, IItemHistoricoServico } from "../types";
import Moment from "react-moment";
import CardHistorico from "./CardHistorico";
import { getIconForAction } from "./CardHistorico/CardRegistry";

export default function ItemHistorico({ 
  item, 
  lastItem = false 
}: { 
  item: IItemHistoricoPlano | IItemHistoricoServico; 
  lastItem?: boolean;
}) {
  const itemPlano = item as IItemHistoricoPlano;
  const origem_evento = itemPlano.origem_evento;
  const { Icon, color } = getIconForAction(item.acao, origem_evento);
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (showTooltip && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const isMobile = window.innerWidth <= 990;
      
      if (isMobile) {
        const horaElement = ref.current.querySelector('.hora-texto') as HTMLElement;
        if (horaElement) {
          const horaRect = horaElement.getBoundingClientRect();
          setPosition({ 
            top: rect.top - 1, 
            left: horaRect.left + horaRect.width / 2
          });
        } else {
          setPosition({ 
            top: rect.top - 1, 
            left: rect.left + rect.width / 2
          });
        }
      } else {
        setPosition({ 
          top: rect.top - 1, 
          left: rect.left + rect.width / 2
        });
      }
    }
  }, [showTooltip]);

  useEffect(() => {
    const handleScroll = () => {
      if (showTooltip && ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const isMobile = window.innerWidth <= 990;
        
        if (isMobile) {
          const horaElement = ref.current.querySelector('.hora-texto') as HTMLElement;
          if (horaElement) {
            const horaRect = horaElement.getBoundingClientRect();
            setPosition({ 
              top: rect.top - 8, 
              left: horaRect.left + horaRect.width / 2
            });
          } else {
            setPosition({ 
              top: rect.top - 8, 
              left: rect.left + rect.width / 2
            });
          }
        } else {
          setPosition({ 
            top: rect.top - 8, 
            left: rect.left + rect.width / 2
          });
        }
      }
    };

    window.addEventListener('scroll', handleScroll, true);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      window.removeEventListener('resize', handleScroll);
    };
  }, [showTooltip]);

  const formatTimeBRT = (date: string) => {
    const d = new Date(date);
    return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };
  
  return (
    <Container>
      <VLine lastItem={lastItem} />
      <div className="items">
        <div 
          ref={ref}
          className="data"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <Moment 
            locale='pt-br' 
            format="DD/MM/YYYY"
            className="data-texto"
          >
            {item.criado}
          </Moment>
          <Moment 
            locale='pt-br' 
            format="HH:mm:ss"
            className="hora-texto"
          >
            {item.criado}
          </Moment>
          {showTooltip && (
            <Tooltip style={{ top: `${position.top}px`, left: `${position.left}px` }}>
              <p><strong>BRT (Brasília):</strong> {formatTimeBRT(item.criado)}</p>
            </Tooltip>
          )}
        </div>
        <div className="icone">
          <Icon color={color} size={16}/>
        </div>
        <CardHistorico item={item} />
      </div>
    </Container>
  );
}
